module.exports = __webpack_public_path__ + "img/logo-white.7cbe1736.png";